import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Rect } from "react-native-svg";

export const IconToggle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconToggle"><Rect x="1.25" y="4.75" width="21.5" height="14.5" rx="7.25" stroke="currentColor" strokeWidth="1.5"/><Circle cx="8.5" cy="12" r="3" fill="currentColor"/></CentralIconBase>;
});

export default IconToggle;
